import { render, staticRenderFns } from "./AdditionalSampleDeclarationDashboard.vue?vue&type=template&id=6b173482&scoped=true&"
import script from "./AdditionalSampleDeclarationDashboard.vue?vue&type=script&lang=js&"
export * from "./AdditionalSampleDeclarationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSampleDeclarationDashboard.vue?vue&type=style&index=0&id=6b173482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b173482",
  null
  
)

export default component.exports